const getters = {
  userInfo: state => state.user.userInfo,
  oss: state => state.user.oss,
  permissions: state => state.user.permissions,
  permissionsObj: state => state.user.permissionsObj,
  routes: state => state.user.routes,
  routeTag: state => state.tag.routeTag
}
export default getters
